import { processCaptions } from 'utils/utils';

export default class TwoPlayersOnboardingController {
  constructor(game) {
    this.game = game;

    this.onEnd = new Phaser.Signal();

    this.cptData = this.game.cache.getJSON('onboarding_05_captions');
    this.cptData = processCaptions(this.game, this.cptData, 'onboarding_05_vo-audioatlas');
    this.game.springRollCaptionsPlugin.setData(this.cptData);
  }

  // processCaptions(cptData, audioName, suffix = '') {
  //   const vosData = this.game.cache.getJSON(audioName);

  //   for (const key in vosData.spritemap) {
  //     if (vosData.spritemap.hasOwnProperty(key)) {
  //       const cpt = (cptData[key + suffix] && cptData[key + suffix][0]) || {};
  //       const vo = vosData.spritemap[key];
  //       cpt.start = 0;
  //       if (vo) {
  //         cpt.end = (vo.end - vo.start) * 1000 + 100;
  //       } else {
  //         cpt.end = 0;
  //       }
  //     }
  //   }
  //   return cptData;
  // }

  playVOs(voIds, avatar = null) {
    this.stopVO();

    this.avatar = avatar;
    this.game.springRollCaptionsPlugin.setData(this.cptData);
    this.voIds = voIds;
    this.ind = 0;
    this.playVO(this.voIds[this.ind]);
  }

  playVO(voId) {
    console.log('<2P>: ' + voId);
    this.audio = this.game.sounds.playVO(voId, {
      spriteID: 'onboarding_05_vo',
      onComplete: this.handleVOEnd,
      onCompleteScope: this,
    });
    this.game.springRollCaptionsPlugin.playCaption(voId);

    if (this.avatar) {
      this.avatar.talk();
    }
  }

  handleVOEnd() {
    this.audio = null;

    this.ind++;
    if (this.ind < this.voIds.length) {
      this.playVO(this.voIds[this.ind]);
    } else {
      if (this.avatar) {
        this.avatar.idle();
      }

      this.onEnd.dispatch();
    }
  }

  stopVO() {
    if (this.audio) {
      this.ind = 999;
      this.audio.stop();
      this.audio = null;
      this.game.springRollCaptionsPlugin.stopCaption();

      if (this.avata) {
        this.avatar.idle();
      }
    }
  }

  destroy() {
    if (this.audio) {
      this.audio.stop();
    }
  }
}
